import { useCallback, useMemo, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslations } from '@lang';

import { SpaPackageFormValues } from '../../SpaPackageForm.schema';

type UsePreferencesParams = {
  form: UseFormReturn<SpaPackageFormValues>;
};

export function usePreferences({ form }: UsePreferencesParams) {
  const { t } = useTranslations();
  const [notesEnabled, setNotesEnabled] = useState(false);
  const [noteValue, setNoteValue] = useState('');

  const handlePreferencesToggle = useCallback(
    (enabled: boolean) => {
      setNotesEnabled(enabled);
      if (!enabled) {
        form.setValue('note', undefined);
        setNoteValue('');
      }
    },
    [form]
  );

  const handleFreeTextChange = useCallback(
    (_categoryId: string, value: string) => {
      setNoteValue(value);
      form.setValue('note', value);
    },
    [form]
  );

  const preferenceCategories = useMemo(
    () => [
      {
        id: 'notes',
        label: t('additional.notes'),
        isFreeText: true,
        freeTextPlaceholder: t('booking.additionnalNotesPlaceholder'),
        freeTextValue: noteValue,
      },
    ],
    [t, noteValue]
  );

  return {
    notesEnabled,
    handlePreferencesToggle,
    handleFreeTextChange,
    preferenceCategories,
  };
}
